export const RESET = 'EXSBREASON_LIST_RESET'
export const SET_ITEMS = 'EXSBREASON_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBREASON_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBREASON_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBREASON_LIST_TOGGLE_LOADING'
